import React from "react";
import ImgPreview from "../ImgPreview";

const GIFT_CARD_IMAGE = encodeURI("/GIFT CARD New_page-0001 (1).jpg");
const GIFT_CARD_MAX_QTY = 1;
const GIFT_CARD_LABEL = "Thank You Card with Gift Item";
// Module-level so ImgPreview's effects see a stable reference and don't refetch every render
const GIFT_CARD_PREVIEW_ITEM = { vetic_variant_id: "gift_card", item_name: GIFT_CARD_LABEL, thumbnail: GIFT_CARD_IMAGE };
const GIFT_CARD_PREVIEW_DATA = [GIFT_CARD_PREVIEW_ITEM];

interface IGiftCardRow {
  qty: string;
  onQtyChange: (qty: string) => void;
  onQtyClick?: () => void;
}

const GiftCardRow: React.FC<IGiftCardRow> = ({ qty, onQtyChange, onQtyClick }) => {
  const isPacked = parseInt(qty) === GIFT_CARD_MAX_QTY;

  const handleQtyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (val === "") {
      onQtyChange("");
      return;
    }
    const clampedQty = Math.min(Math.max(parseInt(val) || 0, 0), GIFT_CARD_MAX_QTY);
    onQtyChange(String(clampedQty));
  };

  return (
    <tr className="text-xs bg-white">
      <td className="py-2 align-middle border-b">
        <ImgPreview data={GIFT_CARD_PREVIEW_DATA} imageitem={GIFT_CARD_PREVIEW_ITEM} />
      </td>
      <td className="px-4 py-2 align-middle text-sm border-b">
        <p>{GIFT_CARD_LABEL}</p>
      </td>
      <td className="px-4 py-2 align-middle text-xs text-[#202223] border-b">
        <p>- | -</p>
      </td>
      <td className="px-4 py-2 align-middle border-b">
        <div className="flex justify-start items-center text-sm">
          <div className="bg-[#F4F4F4] rounded-md w-10 h-10 flex justify-center items-center">{GIFT_CARD_MAX_QTY}</div>
        </div>
      </td>
      <td className="px-4 py-2 align-middle border-b">
        <input
          className="w-full rounded-md border-0 py-1.5 px-3 text-xs font-medium text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:leading-6"
          placeholder="Enter Qty"
          type="number"
          min={0}
          max={GIFT_CARD_MAX_QTY}
          value={qty}
          onClick={onQtyClick}
          onChange={handleQtyChange}
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e" || e.key === "." || e.key === "+") {
              e.preventDefault();
            }
          }}
          onWheel={(e) => e.currentTarget.blur()}
        />
      </td>
      <td className="px-4 py-2 align-middle border-b">
        <div className="h-9 px-1 flex items-center">
          <p className="text-xs text-gray-500 whitespace-nowrap leading-none">Item has no Barcode</p>
        </div>
      </td>
      <td className="px-4 py-2 align-middle border-b">
        <div className="flex justify-start">
          <div
            className={`w-6 h-6 flex items-center justify-center rounded-full ${
              isPacked ? "bg-green-600 border-green-600" : ""
            }`}
          >
            {isPacked && (
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>
        </div>
      </td>
    </tr>
  );
};

export default GiftCardRow;
